// extracted by mini-css-extract-plugin
export default {"container":"Badge_container__wIExj","verticalContainer":"Badge_verticalContainer__SC2HU","image":"Badge_image__GNxAC","name":"Badge_name__FqB8Z"};